// @flow

export { DisplayArgentineNonResidentIgbp } from './display-argentine-non-resident-igbp';
